exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-05b51cf2]:export {\n  primary: #aa4121;\n  secondary: #ccc;\n  gray: #636363;\n}\n.rss-page p[data-v-05b51cf2] {\n  margin-bottom: 0;\n}\n.rss-page .tab-header[data-v-05b51cf2] {\n  padding: 10px 10px 10px 20px;\n  border-radius: 10px 10px 0px 0px;\n}\n.rss-page ul li a[data-v-05b51cf2] {\n  color: black;\n}\n.rss-page ul li a i[data-v-05b51cf2] {\n  color: #aa4121;\n}", ""]);

// exports
